import { z } from 'zod'
import { ApiLocale, Identity } from '~library/enums'
import { enumWithEmpty } from '~library/models'

/** 我的帳號 - 管理者資訊 Schema */
export const myAccountGetAccountInformationSchema = z.object({
  /** 身份 */
  identity: enumWithEmpty(Identity),
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 英文姓名 */
  englishName: z.string(),
  /** 姓名 */
  name: z.string(),
  /** 部門 */
  department: z.string(),
  /** 語系 */
  lang: enumWithEmpty(ApiLocale)
})

/** 我的帳號 - 管理者資訊 */
export interface MyAccountGetAccountInformation
  extends z.infer<typeof myAccountGetAccountInformationSchema> {}
